import { render, staticRenderFns } from "./VolunteerOpportunities.vue?vue&type=template&id=309200ed"
import script from "./VolunteerOpportunities.vue?vue&type=script&lang=js"
export * from "./VolunteerOpportunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports